<template>
  <v-app>
    <div class="not-found">
      <div class="wrapper">
        <img class="img" src="../assets/img/404.png" alt />
        <div class="text">
          <h1>Sayfa bulunamadı!</h1>
          <p>
            Erişmeye çalıştığınız sayfayı bulamadık. Lütfen web adresini kontrol
            edip tekrar deneyiniz.
          </p>
          <p>
            <v-btn href="/" color="purple" dark rounded>ANA SAYFAYA DÖN</v-btn>
          </p>
        </div>
      </div>
      <div class="footer">
        <div class="links">
          <a href="http://fb.me/uteakademi">
            <i class="fab fa-facebook-f"></i>
          </a>
          <a href="https://twitter.com/uteakademi">
            <i class="fab fa-twitter"></i>
          </a>
          <a href="https://www.linkedin.com/company/uteakademi">
            <i class="fab fa-linkedin-in"></i>
          </a>
        </div>
        <p>UTE Akademi A.Ş. © 2020. Tüm hakları saklıdır.</p>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  metaInfo: {
    title: "Sayfa bulunamadı!"
  }
};
</script>

<style lang="scss" scoped>
.not-found {
  font-family: "Roboto";
  font-size: 16px;
  color: $textColor;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  background-image: url(../assets/img/gray-waves.svg);
  background-repeat: no-repeat;
  background-position: right top;
  overflow: hidden;

  .wrapper {
    width: 90%;
    margin: 0;
    position: absolute;
    top: 42%;
    left: 50%;
    transform: translate(-50%, -50%);

    .img {
      display: block;
      width: 100%;
      max-width: 800px;
      margin: 0 auto;
    }

    .text {
      text-align: center;
      max-width: 480px;
      margin: 40px auto 0;
    }
  }

  .footer {
    width: 90%;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: 20px;
    text-align: center;

    .links > a {
      $a-size: 36px;

      display: inline-block;
      background-color: rgba(0, 0, 0, 0.1);
      width: $a-size;
      height: $a-size;
      line-height: $a-size;
      border-radius: 50%;
      text-align: center;
      margin: 5px 10px;
      color: #fff;
      text-decoration: none;

      &:hover {
        background-color: rgba(0, 0, 0, 0.2);
      }
    }

    & > p {
      font-size: 0.8rem;
      margin: 10px 0 0;
    }
  }

  @media (min-width: 600px) and (orientation: landscape) {
    .wrapper {
      max-width: 960px;
      display: flex;
      justify-items: center;
      align-items: center;

      .img {
        width: 50%;
        margin-right: 30px;
      }

      .text {
        text-align: left;
      }
    }
  }

  @media (min-width: 1264px) and (orientation: landscape) {
    background-size: contain;

    .wrapper {
      max-width: 1400px;
      display: flex;
      justify-items: center;
      align-items: center;
      top: 48%;

      .img {
        width: 50%;
        margin-right: 60px;
      }

      .text {
        text-align: left;

        h1 {
          font-size: 2rem;
        }

        p {
          font-size: 1.2rem;
        }
      }
    }
  }
}
</style>
